@let controls = form().controls;
<onyx-dropdown
  [formControl]="controls.excludeCountries"
  label="labels.excludeCountries"
  [options]="countries$ | async"
  [multiple]="true"
  [search]="true"
  [optional]="true"
></onyx-dropdown>

<div class="avoid-features" [formGroup]="controls.avoidFeatures">
  <onyx-input-label label="labels.avoid"></onyx-input-label>

  <div class="items">
    @for (feature of FEATURES; track feature) {
      <onyx-toggle
        [formControlName]="feature"
        [label]="`${DictionaryCode.CALCULATE_ROUTE_FEATURE}.${feature}`"
      ></onyx-toggle>
    }
  </div>
</div>
